import { CommonDateInputProps, DateInput, useInputHelper } from 'framework/form';
import { Typography } from '@mui/material';

const LocationUpdateDateInput = (props: CommonDateInputProps) => {
  const { getLabel } = useInputHelper(props);

  return (
    <>
      <Typography variant="h3" className="copyable-header">
        {getLabel() as string}
      </Typography>
      <DateInput {...props} label="" />
    </>
  );
};

export default LocationUpdateDateInput;
